module.exports = __webpack_public_path__ + "static/media/loyaltyTierBronzeBackground.09b94a9f.png";